import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "ehrFormIsOpen", false);
    },
    closeForm(state) {
        state.formIsOpen = false;
    },
    closeGrid(state) {
        state.gridIsOpen = false;
    },
    openGrid(state) {
        state.gridIsOpen = true;
    },
    showGrid(state) {
        state.gridIsOpen = true;
        state.formIsOpen = false;
        state.ehrFormIsOpen = false;
    },
    showForm(state) {
        state.gridIsOpen = false;
        state.formIsOpen = true;
        state.ehrFormIsOpen = false;
    },
    showEhrForm(state) {
        state.gridIsOpen = false;
        state.formIsOpen = false;
        state.ehrFormIsOpen = true;
    },
    closeEhrForm(state) {
        state.ehrFormIsOpen = false;
    }
}
